import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Stack,
  Paper,
  Fade,
} from '@mui/material'
import localization from '../utils/localization'
import TextLine from './TextLine'

const WalletDetailRow = ({ label, value, icon, color }) => {
  if (!value) return null;
  
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: '16px',
        border: '1px solid rgba(0,0,0,0.04)',
        backgroundColor: '#fff',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 20px rgba(0,0,0,0.04)',
        }
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '10px',
            backgroundColor: `${color}10`,
            color: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <i className={`iconfont ${icon}`} style={{ fontSize: '1.1rem' }}></i>
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              color: '#94A3B8',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              display: 'block',
              mb: 0.5,
            }}
          >
            {label}
          </Typography>
          <Box sx={{ wordBreak: 'break-all' }}>
            <TextLine 
              text={value} 
              style={{ 
                fontSize: '0.95rem', 
                fontWeight: 700, 
                color: '#1E293B',
                fontFamily: icon === 'icon-lock' ? "'JetBrains Mono', monospace" : 'inherit'
              }} 
            />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

function ModalWallet(props) {
  const detail = props.contentInfo?.detail || {};

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          backgroundColor: '#F8FAFC',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {localization.strings.walletDetail}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 2 }}>
            <Stack spacing={1.5}>
              <WalletDetailRow 
                label={localization.strings.title} 
                value={props.contentInfo?.title} 
                icon="icon-tag1" 
                color="#1E88E5" 
              />
              <WalletDetailRow 
                label={localization.strings.coinName} 
                value={detail.coinName} 
                icon="icon-bitcoin" 
                color="#F59E0B" 
              />
              <WalletDetailRow 
                label={localization.strings.address} 
                value={detail.address} 
                icon="icon-link" 
                color="#10B981" 
              />
              
              <Box sx={{ height: 8 }} />
              <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 800, px: 1, mb: 1, display: 'block' }}>
                PRIVATE CREDENTIALS
              </Typography>

              <WalletDetailRow 
                label={localization.strings.pubkey} 
                value={detail.pubKey} 
                icon="icon-key1" 
                color="#6366F1" 
              />
              <WalletDetailRow 
                label={localization.strings.privKey} 
                value={detail.priKey} 
                icon="icon-lock" 
                color="#EF4444" 
              />
              <WalletDetailRow 
                label="KeyStore" 
                value={detail.keyStore} 
                icon="icon-lock" 
                color="#EF4444" 
              />
              <WalletDetailRow 
                label={localization.strings.mnemonic} 
                value={detail.hintWord} 
                icon="icon-file-text" 
                color="#8B5CF6" 
              />
            </Stack>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalWallet
